import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import {
  BuyerSettingsResponse,
  CompanySettingsResponse,
} from './dtos/settings.dto';
import { AllBuyerSettings, CompanySettings } from '../models/settings.model';
import { SettingsMapper } from './mappers/settings.mapper';

@Injectable({ providedIn: 'root' })
export class SettingsApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}`;

  private readonly _mapper = new SettingsMapper();

  public getAllBuyerSettings(): Observable<AllBuyerSettings> {
    return this._http
      .get<BuyerSettingsResponse>(`${this._baseUrl}/buyerConfigSettings`)
      .pipe(map((response) => this._mapper.fromDto(response.data)));
  }

  public getCompanySettings(companyId: number): Observable<CompanySettings> {
    return this._http
      .get<CompanySettingsResponse>(`${this._baseUrl}/company/${companyId}`)
      .pipe(map((response) => this._mapper.fromCompanyDto(response.company)));
  }
}
